import { Alert, Typography } from '@mui/material'

export default function SubmitStatus(props: TODO) {
  if (props.isLoading) {
    return (
      <Alert severity="info">
        <Typography variant="h3">Performing Edit</Typography>
        <Typography>This will take a moment.</Typography>
      </Alert>
    )
  }

  if (props.isSuccess) {
    return (
      <Alert>
        <Typography variant="h3">Success</Typography>
        <Typography>Documents were successfully edited.</Typography>
      </Alert>
    )
  }

  if (props.isError) {
    return (
      <Alert severity="error">
        <Typography variant="h3">Error:</Typography>
        <Typography>There was an issue modifying the documents.</Typography>
      </Alert>
    )
  }

  return
}
